import React from 'react';

import Counter from './Counter';

function CounterPage() {
  return (
    <div className="App" style={{marginTop: "15%"}}>
      <h1>Counter App</h1>
      <Counter />
    </div>
  );
}

export default CounterPage;